import type { QuizQuestion } from "../content/types";

function seedFor(value: string): number {
  return [...value].reduce(
    (seed, character) => (seed * 31 + character.charCodeAt(0)) >>> 0,
    7,
  );
}

export function shuffleQuizQuestion(
  question: QuizQuestion,
  salt: string,
): QuizQuestion {
  const order = question.choices.map((_, index) => index);
  let seed = seedFor(`${salt}:${question.id}`);

  for (let index = order.length - 1; index > 0; index -= 1) {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    const destination = seed % (index + 1);
    [order[index], order[destination]] = [order[destination], order[index]];
  }

  return {
    ...question,
    choices: order.map((index) => question.choices[index]),
    correctIndex: order.indexOf(question.correctIndex),
  };
}
